const envConfig = window.config.env

export const envModes = envConfig.envModes
export const envMode = envConfig.envMode
export const version = envConfig.version
export const buildNumber = envConfig.buildNumber

export default envConfig
